module.exports = __webpack_public_path__ + "img/onboarding_2.bcefe01a.png";